import Vue from 'vue'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

const state = {
  // form
  targetId: Constants.RegisterHash,
  values: {}
}

const getters = {
  get: state => state,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        case 'createdAt':
        case 'updatedAt':
          return Utility.dateFormat(value, 'YYYY/MM/DD HH:mm')
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  /**
   * 初期読出し
   */
  loadModel ({commit}, {targetId, serviceParams}) {
    commit('setTargetId', targetId)

    return new Promise((resolve, reject) => {
      // データを読出し
      ApiManager.request(
        ['service'],
        ['v1ServiceDetailGet'],
        [serviceParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            // 正常処理
            commit('inited', res[0].data.serviceBasicInfo)
            console.log('values', state.values)
            resolve(res[0].data)

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  
  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // init
  inited (state, data) {
    Vue.set(state, 'values', data)
    Vue.set(state.values, 'inpServiceName', data.serviceName)
    Vue.set(state.values, 'inpStatus', data.serviceStatus)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
